var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:`dg-paragraph ${_vm.color}`,on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }